import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {KoeffizienteM2RowData} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';

@Component({
  selector: '[appTableKoeffizienteDataRow]',
  templateUrl: './table-koffiziente-data-row.component.html',
  styleUrl: './table-koffiziente-data-row.component.scss',
  standalone: false
})
export class TableKoffizienteDataRowComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() rowData: KoeffizienteM2RowData;
  @Input() rowHeader: string;
  @Input() isHeader: boolean;

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
